'use strict'

export class init {
    constructor() {
        this.donateMenu = document.querySelector('.donation-menu__wrapper');
        this.bankInfoMenu = document.querySelector('.donation-menu__wrapper.donation-menu_bank');
        this.cardInfoMenu = document.querySelector('.donation-menu__wrapper.donation-menu_card');
        this.bankMenuItem = document.querySelector('.donation-menu-item__wrapper.donation-menu-item__bank');
        this.cardMenuItem = document.querySelector('.donation-menu-item__wrapper.donation-menu-item__card');
        this.backToDonateMenuButton = document.querySelectorAll('.donation-menu__wrapper .donation-menu__back-button');
        this.animationDelay = 1500;
        this.changeDonateButtonLayout();
        this.bindHandlers();
    }

    bindHandlers() {
        const bankMenuItem = this.bankMenuItem;
        const cardMenuItem = this.cardMenuItem;
        const backToDonateMenuButton = this.backToDonateMenuButton;
        const donateMenu = this.donateMenu.querySelectorAll('.donation-menu-item');
        const bankInfoMenu = this.bankInfoMenu.querySelectorAll('.donation-menu-item');
        const cardInfoMenu = this.cardInfoMenu.querySelectorAll('.donation-menu-item');

        bankMenuItem.addEventListener('click', (event) => {
            this.animateItems(bankInfoMenu);
            this.toggleDonateOptionsState(this.bankInfoMenu);
        })

        backToDonateMenuButton.forEach(button => {
            button.addEventListener('click', (event) => {
                const menuType = event.target.getAttribute("data-type");
                if (menuType === 'bank') {
                    this.animateItems(donateMenu);
                    this.toggleDonateOptionsState(this.bankInfoMenu);
                    this.hideBankMenuItemContent(bankInfoMenu);
                } else if (menuType === 'card') {
                    this.animateItems(donateMenu);
                    this.toggleDonateOptionsState(this.cardInfoMenu);
                }
            })
        })

        bankInfoMenu.forEach(item => {
            if (item.querySelector('.donation-menu-item__text')) {
                item.querySelector('.donation-menu-item__text').addEventListener('click', (event) => {
                    if (item) {
                        item.classList.toggle('donation-menu-item__wrapper_full');
                    }
                });
            }
            const paymentInfoItems = item.querySelectorAll('.payment-info');
            const copyButtons = item.querySelectorAll('.payment-info__copy-icon-wrapper');
            if (copyButtons) {
                copyButtons.forEach((button) => {
                    button.addEventListener('click', (event) => {
                        const description = event.target.closest('.payment-info__description').querySelector('.payment-info__description-text')
                        this.copyText(description.innerText.trim());
                        this.showCopyLabel(button);
                    });
                })
            }

            paymentInfoItems.forEach(item => {
                item.addEventListener('click', (event) => {
                    const copyButton = item.querySelector('.payment-info__copy-icon-wrapper')
                    copyButton.click();
                })
            })
        })

        cardMenuItem.addEventListener('click', () => {
            this.animateItems(cardInfoMenu);
            this.toggleDonateOptionsState(this.cardInfoMenu);
        })
    }

    changeDonateButtonLayout() {
        const headerButton = document.querySelector('header .donate');
        headerButton.classList.add('donate_close');
        headerButton.setAttribute('href', '/');
        headerButton.querySelector('img').setAttribute('src', '/assets/frontend/img/donation/cross.svg');
        headerButton.querySelector('span').innerText = '';
    }

    toggleDonateOptionsState(el) {
        this.donateMenu.classList.toggle('donation-menu__wrapper_inactive');
        this.donateMenu.classList.toggle('donation-menu__wrapper_active');
        el.classList.toggle('donation-menu__wrapper_active');
        el.classList.toggle('donation-menu__wrapper_inactive');
    }

    hideBankMenuItemContent(items) {
        items.forEach((item => {
            if (item.classList.contains('donation-menu-item__wrapper_full')) {
                item.classList.remove('donation-menu-item__wrapper_full');
            }
        }))
    }

    animateItems(items) {
        items.forEach(item => {
            item.classList.toggle('donation-menu-item_animate');
        })
        setTimeout(() => {
            items.forEach(item => {
                item.classList.toggle('donation-menu-item_animate');
            })
        }, this.animationDelay);
    }

    copyText(text) {
        navigator.clipboard.writeText(text);
    }

    showCopyLabel(copyWrapper) {
        const label = copyWrapper.querySelector('.payment-info__copy-label');
        copyWrapper.style.display = 'flex';
        if (label) {
            label.classList.add('payment-info__copy-label_active');
            setTimeout(() => {
                label.classList.remove('payment-info__copy-label_active');
                copyWrapper.style.display = null;
            }, this.animationDelay)
        }
    }
}
